export const BI_SCHEMA = {
  player: {
    downloadPage: {
      track: {
        buy: {
          clicked: {
            id: 209,
            name: 'player.downloadPage.track.buy.clicked',
            fields: [
              'albumID',
              'artifactVersion',
              'currency',
              'isOwner',
              'compId',
              'playerVersion',
              'price',
              'sessionId',
              'trackID',
              'trackIdxInAlbum',
            ],
          },
        },
      },
      album: {
        buy: {
          clicked: {
            id: 212,
            name: 'player.downloadPage.album.buy.clicked',
            fields: [
              'albumID',
              'artifactVersion',
              'currency',
              'isOwner',
              'compId',
              'playerVersion',
              'price',
              'sessionId',
            ],
          },
        },
      },
      close: {
        click: {
          id: 213,
          name: 'player.downloadPage.close.click',
          fields: ['buttonName', 'albumID', 'artifactVersion', 'isOwner', 'compId', 'playerVersion', 'sessionId'],
        },
      },
      'pre-opened': {
        id: 214,
        name: 'player.downloadPage.pre-opened',
        fields: ['albumID', 'artifactVersion', 'playerVersion', 'sessionId', 'compId', 'isOwner'],
      },
      opened: {
        id: 215,
        name: 'player.downloadPage.opened',
        fields: [
          'albumID',
          'artifactVersion',
          'isOwner',
          'loading_time',
          'compId',
          'playerVersion',
          'sessionId',
          'externalLink',
          'getOption',
        ],
      },
      externalLink: {
        clicked: {
          id: 216,
          name: 'player.downloadPage.externalLink.clicked',
          fields: [
            'buttonName',
            'type',
            'musicPlatform',
            'albumID',
            'artifactVersion',
            'isOwner',
            'compId',
            'playerVersion',
            'sessionId',
          ],
        },
      },
      subscribeToDownload: {
        clicked: {
          id: 217,
          name: 'player.downloadPage.subscribeToDownload.clicked',
          fields: ['type', 'albumID', 'artifactVersion', 'isOwner', 'compId', 'playerVersion', 'sessionId'],
        },
      },
      enterEmail: {
        validation: {
          Complete: {
            id: 218,
            name: 'player.downloadPage.enterEmail.validation.Complete',
            fields: [
              'isSuccess',
              'errorMsg',
              'type',
              'albumID',
              'artifactVersion',
              'isOwner',
              'compId',
              'playerVersion',
              'sessionId',
            ],
          },
        },
      },
      back: {
        clicked: {
          id: 221,
          name: 'player.downloadPage.back.clicked',
          fields: ['albumID', 'artifactVersion', 'isOwner', 'compId', 'playerVersion', 'sessionId', 'type'],
        },
      },
      continue: {
        clicked: {
          id: 219,
          name: 'player.downloadPage.continue.clicked',
          fields: [
            'isSuccess',
            'errorMsg',
            'minPrice',
            'currency',
            'price',
            'type',
            'albumID',
            'artifactVersion',
            'isOwner',
            'compId',
            'playerVersion',
            'sessionId',
          ],
        },
      },
      download: {
        clicked: {
          id: 220,
          name: 'player.downloadPage.download.clicked',
          fields: [
            'format',
            'type',
            'albumID',
            'trackID',
            'artifactVersion',
            'isOwner',
            'compId',
            'playerVersion',
            'sessionId',
          ],
        },
      },
      paymentMethodSelected: {
        id: 222,
        name: 'player.downloadPage.paymentMethodSelected',
        fields: [
          'method',
          'type',
          'currency',
          'compId',
          'price',
          'albumID',
          'artifactVersion',
          'isOwner',
          'compId',
          'playerVersion',
          'sessionId',
        ],
      },
      emailEntered: {
        id: 223,
        name: 'player.downloadPage.emailEntered',
        fields: [
          'isSuccess',
          'type',
          'compId',
          'albumID',
          'artifactVersion',
          'isOwner',
          'compId',
          'playerVersion',
          'sessionId',
        ],
      },
      cc: {
        paymentConfirmed: {
          id: 224,
          name: 'player.downloadPage.cc.paymentConfirmed',
          fields: [
            'isSuccess',
            'type',
            'compId',
            'albumID',
            'artifactVersion',
            'isOwner',
            'compId',
            'playerVersion',
            'sessionId',
          ],
        },
      },
      paymentCompleted: {
        id: 225,
        name: 'player.downloadPage.paymentCompleted',
        fields: [
          'errorMessage',
          'paymentStatus',
          'type',
          'compId',
          'albumID',
          'artifactVersion',
          'isOwner',
          'compId',
          'playerVersion',
          'sessionId',
        ],
      },
      retryPaymentClicked: {
        id: 226,
        name: 'player.downloadPage.retryPaymentClicked',
        fields: ['type', 'compId', 'albumID', 'artifactVersion', 'isOwner', 'compId', 'playerVersion', 'sessionId'],
      },
    },
    track: {
      shared: {
        id: 202,
        name: 'player.track.shared',
        fields: [
          'albumID',
          'artifactVersion',
          'compId',
          'isOwner',
          'playerVersion',
          'sessionId',
          'socialNetwork',
          'trackID',
          'trackIdxInAlbum',
        ],
      },
      purchase: {
        clicked: {
          id: 194,
          name: 'player.track.purchase.clicked',
          fields: [
            'albumID',
            'artifactVersion',
            'currency',
            'isOwner',
            'origin',
            'compId',
            'playerVersion',
            'price',
            'sendToDownloadPage',
            'sessionId',
            'trackID',
            'trackIdxInAlbum',
          ],
        },
      },
    },
    album: {
      purchase: {
        clicked: {
          id: 198,
          name: 'player.album.purchase.clicked',
          fields: [
            'albumID',
            'artifactVersion',
            'currency',
            'isOwner',
            'origin',
            'compId',
            'playerVersion',
            'price',
            'sendToDownloadPage',
            'sessionId',
          ],
        },
      },
    },
  },
};
